module.exports = __webpack_public_path__ + "img/aboutBanner.f8bf2c8a.png";